// @ts-nocheck
import React, { useState, useEffect, useMemo, useContext, useCallback } from 'react';
import Router, { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import Breadcrumbs from '@/components/breadcrumbs';
import Storage from '@/utils/storage';
import { Box, Card, Flex, Tabs, Tooltip } from "@mantine/core";
import SCMessageBarContext from '@/utils/contexts/sc-message-bar-context';
import constants from '@/utils/constants';
import tabStyles from '@/styles/Tabs.module.css';
import { useQuery } from "@tanstack/react-query";
import featureService from '@/services/feature/feature-service';
import NewText from "@/PageComponents/Premium/NewText";
import VanStockList from '@/PageComponents/Table/Component Tables/VanStockList';
import { createFileRoute } from '@tanstack/react-router'

function VansList() {

    const messageBarContext = useContext(SCMessageBarContext);

    const router = useRouter()

    const {data: hasVanStock} = useQuery(['hasVanStock'], () => featureService.getFeature(constants.features.VAN_STOCK))

    const [activeTab, setActiveTab] = useState<string | null>(null);

    const setInitialTab = (tabDataLocal = tabData) => {
        const tab = router.query.tab as string // TODO(tanstack-router): verify router.query → useParams/useSearch
        if (tab && tabDataLocal[tab] && tabDataLocal[tab].access !== false) {
            setActiveTab(tab)
        }
        else {
            setActiveTab(Object.entries(tabDataLocal).find(([, x]: any) => (x as any).access)?.[0] || 'vans');
        }
    };

    const tabData = useMemo(() => {
        let tabs: any = {};

        if (!!hasVanStock) {
            tabs.vans = {
                label: 'Vans',
                new: true,
                access: !!hasVanStock,
            };
           
        }

        setInitialTab(tabs);

        return tabs;
    }, [hasVanStock])

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    useEffect(() => {
        getAccessStatus();
    }, []);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    const handleTabChange = (newTabName: string | null) => {
        setActiveTab(newTabName)
        router.replace(router.asPath.split('?')[0] + '?tab=' + newTabName)
    }

    const tabs = <>
        <Tabs value={activeTab} onChange={handleTabChange}
            classNames={{
                tab: tabStyles.scTab,
                list: tabStyles.scTabList,
                tabLabel: tabStyles.scTabLabel
            }}
        >
            <Tabs.List mb={0} pb={0}>
                {
                    Object.entries(tabData).filter(([, x]: any) => true).map(
                        ([tabName, d]: any) => d &&
                            <Tooltip label={d.disabledLabel || ''}
                                key={tabName + 'tab'}
                                position={'bottom'}
                                disabled={!d.disabled || !d.disabledLabel}
                                color={'scBlue'}
                                openDelay={1000}
                                events={{ hover: true, focus: true, touch: true }}
                            >
                                <Tabs.Tab value={tabName}
                                    disabled={!d.access || d.disabled}
                                    color={(tabName === 'vans') ? 'yellow' : 'scBlue'}
                                >
                                    <Flex align={'center'} gap={5}>
                                        {d.label} {((tabName === 'vans')) && <NewText />} 
                                    </Flex>
                                </Tabs.Tab>
                            </Tooltip>
                    )
                }
 
            </Tabs.List>
        </Tabs>
    </>

    return (
        <>
            <Box
                mt={'var(--mantine-spacing-sm)'}
                px={'var(--mantine-spacing-md)'}
                mb={0}
                pb={0}
                style={(theme: any) => ({ borderBottom: `${theme.colors.gray[2]} 2px solid` })}
            >
                <Box my={'var(--mantine-spacing-md)'}>
                    <Breadcrumbs currPage={{
                        text: tabData[activeTab || '']?.label,
                        link: `/inventory/list?tab=${activeTab || ''}`,
                        type: 'list'
                    }} />
                </Box>
                {/* {tabs} */}
            </Box>

   
            <Box
                h={`calc(100vh - 135px${((messageBarContext as any)?.isActive ? ` - ${constants.messageBarMargin}px` : "")})`}
                style={(theme: any) => ({
                    backgroundColor: theme.colors.gray[1]
                })}
                p={'var(--mantine-spacing-xs)'}
            >
                <Card
                    style={{
                        backgroundColor: 'white'
                    }}
                    p={'var(--mantine-spacing-md)'}
                    radius={'md'}
                >
                    {
                        activeTab === 'vans' &&
                        <VanStockList /> 
                    }
                </Card>

            </Box>

        </>
    )
}

export default VansList;

export const Route = createFileRoute('/_authenticated/van/list')({ component: VansList })
